<script>
import {defineComponent} from 'vue'
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";
import moment from "moment";
import ExpenseIndicatorForm from "@/views/expence/indicators/ExpenseIndicatorForm.vue";

export default defineComponent({
  name: "ExpenseIndicatorList",
  components: {ExpenseIndicatorForm},
  computed: {
    moment() {
      return moment
    }
  },
  data() {
    return {
      loading: false,
      expence_id: null,
      tableData: [],
      page: 1,
      totalCount: 0,
      limit: 10,
    }
  },
  methods: {
    indexMethod(index) {
      return index + (this.page - 1) * this.limit + 1
    },
    handleCurrentChange() {
      this.getExpenseIndicators();
    },
    handleSizeChange() {
      this.page = 1;
      this.getExpenseIndicators();
    },
    onClickDelete(id) {
      ElMessageBox.confirm(
          'Ma\'lumoitni o\'chirasizmi?',
          'Diqqat!',
          {
            confirmButtonText: 'Ha',
            cancelButtonText: 'Bekor qilish',
            type: 'warning',
          }
      )
          .then(() => {
            this.loading = true
            this.$http.delete(`/api/v1/expence-indicators/${id}`).then(() => {
              ElMessage({
                type: 'success',
                message: 'Muvaffaqqiyatli o\'chirildi',
              })
              this.getExpenseIndicators();
            }).catch(() => {
              ElNotification({
                type: 'error',
                title: 'Xatolik',
                message: 'Iltimos, qayta urinib ko\'ring',
              })
            }).finally(() => {
              this.loading = false
            })

          })
          .catch(() => {
            ElMessage({
              type: 'info',
              message: 'O\'chirish bekor qilindi',
            })
          })
    },

    getExpenseIndicators() {
      this.loading = true;
      this.$http.get(`api/v1/expence-indicators`, {
        params: {
          expence_id: this.expence_id,
          limit: this.limit,
          offset: this.limit * (this.page - 1)
        }
      }).then(({data}) => {
        this.tableData = data.data;
        this.totalCount = data.count;
      }).catch(({response}) => {
        ElNotification.error({message: response.data.message || "Ma'lumot yuklashda xatolik sodir bo'ldi. Iltimos, qayta urinib ko'ring."})
      }).finally(() => {
        this.loading = false
      })
    },
  },
  mounted() {
    if (this.$route.query.parent) {
      this.expence_id = parseInt(this.$route.query.parent);
      this.getExpenseIndicators()
    }
  }
})
</script>

<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <div>
        <el-button type="warning" size="small" @click="$router.go(-1)">Orqaga</el-button>
      </div>
      <expense-indicator-form :expense="expence_id" @getData="getExpenseIndicators"/>
    </div>
    <el-table :data="tableData" class="table" border height="calc(100vh - 230px)">
      <el-table-column type="index" label="T/R" width="80" :index="indexMethod" align="center"/>
      <el-table-column label="Yil" prop="year"/>
      <el-table-column label="Chorak" prop="quarter"/>
      <el-table-column label="Miqdor" prop="amount"/>
      <el-table-column label="" align="center" width="200">
        <template #default="scope">
          <expense-indicator-form :id="scope.row.id" :expense="expence_id" @getData="getExpenseIndicators"/>
          <el-button style="margin-left: 8px" type="danger" size="small" @click="onClickDelete(scope.row.id)">
            O'chirish
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <div>Umumiy soni: {{ totalCount }}</div>
      <el-pagination
          background
          layout="sizes, prev, pager, next"
          :total="totalCount"
          v-model:page-size="limit"
          v-model:current-page="page"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  gap: 10px;
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
</style>
